import React from 'react';
export function PaymentIcons() {
  return <div className="flex flex-wrap items-center justify-center gap-2 mt-4" data-id="element-70">
      {/* Visa */}
      <div className="bg-white rounded flex items-center justify-center px-2" style={{
      width: '52px',
      height: '30px'
    }} data-id="element-71">
        <svg viewBox="0 0 80 26" width="44" height="14" xmlns="http://www.w3.org/2000/svg" data-id="element-72">
          <path d="M30.5 0.8L26.2 25.2H32.3L36.6 0.8H30.5Z" fill="#1A1F71" data-id="element-73" />
          <path d="M52.8 0.8L47.1 17.1L46.4 13.5L44.2 2.8C43.8 1.2 42.5 0.8 40.9 0.8H31.2L31.1 1.3C33.5 1.9 35.7 2.9 37.6 4.2L43.1 25.2H49.4L59.1 0.8H52.8Z" fill="#1A1F71" data-id="element-74" />
          <path d="M68.2 0.8H62.8C61.4 0.8 60.3 1.5 59.8 2.7L50.8 25.2H57.1L58.4 21.5H66.1L66.9 25.2H72.5L68.2 0.8ZM60.2 16.9L63.4 8.1L65.2 16.9H60.2Z" fill="#1A1F71" data-id="element-75" />
          <path d="M22.3 0.8L16.7 17.3L16.1 14.2C14.8 9.8 10.8 5.8 6.3 3.7L11.4 25.2H17.8L28.7 0.8H22.3Z" fill="#1A1F71" data-id="element-76" />
          <path d="M9.4 0.8H0.1L0 1.3C7.3 3.1 12.2 7.3 14.2 12.5L12.1 2.8C11.7 1.2 10.7 0.8 9.4 0.8Z" fill="#F9A533" data-id="element-77" />
        </svg>
      </div>

      {/* Mastercard */}
      <div className="bg-white rounded flex items-center justify-center px-1" style={{
      width: '52px',
      height: '30px'
    }} data-id="element-78">
        <svg viewBox="0 0 50 32" width="32" height="20" xmlns="http://www.w3.org/2000/svg" data-id="element-79">
          <circle cx="18" cy="16" r="14" fill="#EB001B" data-id="element-80" />
          <circle cx="32" cy="16" r="14" fill="#F79E1B" data-id="element-81" />
          <path d="M25 5.5C27.8 7.7 29.7 11 29.7 14.7C29.7 18.4 27.8 21.7 25 23.9C22.2 21.7 20.3 18.4 20.3 14.7C20.3 11 22.2 7.7 25 5.5Z" fill="#FF5F00" data-id="element-82" />
        </svg>
      </div>

      {/* OXXO */}
      <div className="rounded flex items-center justify-center" style={{
      width: '52px',
      height: '30px',
      background: '#DA291C'
    }} data-id="element-83">
        <span style={{
        fontFamily: 'Arial Black, sans-serif',
        fontWeight: 900,
        fontSize: '11px',
        color: 'white',
        letterSpacing: '-0.5px'
      }} data-id="element-84">
          OXXO
        </span>
      </div>

      {/* Mercado Pago */}
      <div className="rounded flex items-center justify-center gap-1" style={{
      width: '72px',
      height: '30px',
      background: '#009EE3'
    }} data-id="element-85">
        <svg viewBox="0 0 16 16" width="14" height="14" xmlns="http://www.w3.org/2000/svg" data-id="element-86">
          <circle cx="8" cy="8" r="7" fill="white" fillOpacity="0.25" data-id="element-87" />
          <path d="M4.5 8L7 10.5L11.5 5.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-88" />
        </svg>
        <span style={{
        fontFamily: 'Arial, sans-serif',
        fontWeight: 700,
        fontSize: '8px',
        color: 'white',
        lineHeight: 1.1
      }} data-id="element-89">
          MERCADO
          <br data-id="element-90" />
          PAGO
        </span>
      </div>

      {/* Secure lock */}
      <div className="flex items-center gap-1 px-2 rounded" style={{
      height: '30px',
      background: 'rgba(201,168,76,0.12)',
      border: '1px solid rgba(201,168,76,0.3)'
    }} data-id="element-91">
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-92">
          <rect x="3" y="11" width="18" height="11" rx="2" stroke="#C9A84C" strokeWidth="2.5" data-id="element-93" />
          <path d="M7 11V7C7 4.24 9.24 2 12 2C14.76 2 17 4.24 17 7V11" stroke="#C9A84C" strokeWidth="2.5" strokeLinecap="round" data-id="element-94" />
        </svg>
        <span style={{
        fontFamily: 'Lato, sans-serif',
        fontSize: '9px',
        color: '#C9A84C',
        fontWeight: 700,
        letterSpacing: '0.05em'
      }} data-id="element-95">
          SEGURO
        </span>
      </div>
    </div>;
}